<template>
  <div class="footer">
    <div class="footer_con">
      <p>
        公司名称：
        <span v-if="RoutingJudgment">广州易签宝网络科技有限公司</span>
        <span v-else>杭州天谷信息科技有限公司</span>
      </p>
      <p>
        销售热线：
        <span v-if="RoutingJudgment">0571-88231350</span>
        <span v-else>0571-85785223</span>
      </p>
      <p>备案信息：浙ICP备11026113号</p>
      <p>增值电信业务经营许可证浙B2-20180376</p>
      <p>浙公网安备 33010602006438号</p>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    RoutingJudgment() {
      return window.location.hostname === 'guangzhou.esign.cn'
    },
  },
}
</script>

<style lang="less">
.footer {
  min-width: 1200px;
}
</style>
<style lang="less" scoped>
.footer {
  width: 100%;
  min-height: 58px;
  background: #eee;
  .footer_con {
    width: 1200px;
    display: flex;
    justify-content: space-between;
    text-align: center;
    flex-direction: row;
    margin: auto;
    p {
      font-size: 12px;
      margin: 0;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      line-height: 58px;
      color: #989898;
    }
  }
}
</style>
